import * as React from "react";

import { InteractiveSearchRequestParams } from "../Definitions";
import { GlassIcon } from "./index";

import styles from "../InteractiveSearch.css";

type SearchProps = {
    name: string | null;
    onClick: (update: Partial<InteractiveSearchRequestParams>) => void;
}

export const Search = (props: SearchProps): JSX.Element => {
    const [inputs, setInputs] = React.useState({searchName: props.name ?? ""});
    const [hasError, setHasError] = React.useState(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const name = event.target.name;
        const value = event.target.value;

        const error = value.length < 3
        setHasError(error);

        setInputs(values => ({...values, [name]: value}));
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();

        if (!hasError) {
            props.onClick({
                "searchTerm": inputs.searchName ? inputs.searchName : null
            });
        }
    }

    return (
        <div
        >
            <form
                onSubmit={handleSubmit}
                className={styles.searchForm}
            >
                <div className={styles.inputContainer}>
                    <input
                        type="text"
                        name="searchName"
                        placeholder="Suche nach..."
                        value={inputs.searchName || ""}
                        onChange={handleChange}
                        className={styles.searchInput}
                    />

                    <button
                        className={styles.submitBtn}
                        type="submit"
                    >
                        <span className={styles.glass}>
                            <GlassIcon />
                        </span>
                    </button>
                </div>
                {
                    hasError
                        ? <p className={styles.error}>Bitte mindestens 3 Zeichen eingeben</p>
                        : null
                }
            </form>
        </div>
    )
}
